/**
 * Form validation
 * Using jQuery since it's present
 *
 */
const init = function () {

	$('input.js-number-filter').keyup(function (event) {

		// skip for arrow keys
		if (event.which >= 37 && event.which <= 40) {
			event.preventDefault();
		}

		var currentVal = $(this).val();
		var testDecimal = testDecimals(currentVal);

		if (testDecimal.length > 1) {
			alert('Only one decimal point is allowed');
			currentVal = currentVal.slice(0, -1);
		}

		$(this).val(replaceCommas(currentVal));

	});

};


const testDecimals = function (currentVal) {
	var count;
	currentVal.match(/\./g) === null ? count = 0 : count = currentVal.match(/\./g);
	return count;
}


const replaceCommas = function (yourNumber) {

	var components = yourNumber.toString().split(".");

	if (components.length === 1) {
		components[0] = yourNumber;
		components[0] = components[0].replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	if (components.length === 2) {
		components[1] = components[1].replace(/\D/g, "");
	}

	return components.join(".");
}


const api = {
	init: init
};

export default api;